import { BehaviorSubject, Observable } from 'rxjs';

/**
 * A helper class to hold track of busy | idle states. Useful for loading animations for example.
 */
export class BusyController {
  #subject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  /**
   * Get underlying subject.
   */
  get asSubject() {
    return this.#subject;
  }

  /**
   * A multicasting observable that emits an event every time the busy / idle state changes.
   */
  get isBusy$(): Observable<boolean> {
    return this.#subject.asObservable();
  }

  /**
   * Switch to busy mode.
   */
  busy(): void {
    this.#subject.next(true);
  }

  /**
   * Switch to idle mode.
   */
  idle(): void {
    this.#subject.next(false);
  }

  /**
   * Toggle the busy/idle mode.
   */
  toggle() {
    this.#subject.next(!this.#subject.value);
  }

  /**
   * Set the next state directly.
   */
  setState(busy: boolean) {
    this.#subject.next(busy);
  }
}
